export default __webpack_public_path__ + "static/media/469.072caa4b.png";